export default {
  'pages.layouts.userLayout.title':
    'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  // 用户管理页面
  'pages.userManagement.title': '用户列表',
  'pages.userManagement.id': 'ID',
  'pages.userManagement.email': '邮箱',
  'pages.userManagement.username': '用户名',
  'pages.userManagement.nickname': '昵称',
  'pages.userManagement.fullName': '全名',
  'pages.userManagement.phone': '手机号',
  'pages.userManagement.password': '密码',
  'pages.userManagement.status': '状态',
  'pages.userManagement.status.active': '正常',
  'pages.userManagement.status.suspended': '已停用',
  'pages.userManagement.status.pending': '待验证',
  'pages.userManagement.subscriptionTier': '订阅等级',
  'pages.userManagement.tier.free': '免费版',
  'pages.userManagement.tier.pro': '专业版',
  'pages.userManagement.tier.unlimited': '无限版',
  'pages.userManagement.emailVerified': '邮箱验证',
  'pages.userManagement.verified': '已验证',
  'pages.userManagement.unverified': '未验证',
  'pages.userManagement.quota': '配额',
  'pages.userManagement.dailyQuotaLimit': '每日配额限制',
  'pages.userManagement.oauth': 'OAuth',
  'pages.userManagement.createdAt': '创建时间',
  'pages.userManagement.actions': '操作',
  'pages.userManagement.detail': '详情',
  'pages.userManagement.edit': '编辑',
  'pages.userManagement.more': '更多',
  'pages.userManagement.refresh': '刷新',
  'pages.userManagement.newUser': '新建用户',
  'pages.userManagement.createUser': '创建用户',
  'pages.userManagement.editUser': '编辑用户',
  'pages.userManagement.userDetail': '用户详情',
  'pages.userManagement.basicInfo': '基本信息',
  'pages.userManagement.subscriptionSettings': '订阅设置',
  'pages.userManagement.subscriptionInfo': '订阅信息',
  'pages.userManagement.subscriptionExpiresAt': '订阅到期时间',
  'pages.userManagement.autoRenew': '自动续订',
  'pages.userManagement.otherSettings': '其他设置',
  'pages.userManagement.quotaInfo': '配额信息',
  'pages.userManagement.preferences': '偏好设置',
  'pages.userManagement.loginInfo': '登录信息',
  'pages.userManagement.oauthConnections': 'OAuth 连接',
  'pages.userManagement.language': '语言',
  'pages.userManagement.timezone': '时区',
  'pages.userManagement.emailNotifications': '启用邮件通知',
  'pages.userManagement.marketingEmails': '接收营销邮件',
  'pages.userManagement.keyword': '关键词',
  'pages.userManagement.keywordPlaceholder': '邮箱/用户名/昵称',
  'pages.userManagement.selected': '已选择',
  'pages.userManagement.item': '项',
  'pages.userManagement.batchDelete': '批量删除',
  'pages.userManagement.createSuccess': '创建成功',
  'pages.userManagement.updateSuccess': '更新成功',
  'pages.userManagement.deleteSuccess': '删除成功',
  'pages.userManagement.batchDeleteSuccess': '批量删除成功',
  'pages.userManagement.emailRequired': '请输入邮箱',
  'pages.userManagement.emailInvalid': '请输入有效的邮箱地址',

  // 系统配置页面
  'pages.systemConfig.title': '系统配置',
  'pages.systemConfig.classify.title': '分类管理',
  'pages.systemConfig.classify.name': '分类名称',
  'pages.systemConfig.classify.key': '分类标识',
  'pages.systemConfig.classify.pid': '父级分类',
  'pages.systemConfig.classify.icon': '图标',
  'pages.systemConfig.classify.sort': '排序',
  'pages.systemConfig.classify.status': '状态',
  'pages.systemConfig.classify.info': '说明',
  'pages.systemConfig.classify.createdAt': '创建时间',
  'pages.systemConfig.classify.actions': '操作',
  'pages.systemConfig.classify.create': '新建分类',
  'pages.systemConfig.classify.edit': '编辑分类',
  'pages.systemConfig.classify.delete': '删除',
  'pages.systemConfig.classify.deleteConfirm': '确定要删除此分类吗？删除后不可恢复。',
  'pages.systemConfig.classify.createSuccess': '创建成功',
  'pages.systemConfig.classify.updateSuccess': '更新成功',
  'pages.systemConfig.classify.deleteSuccess': '删除成功',
  'pages.systemConfig.classify.topLevel': '顶级分类',
  'pages.systemConfig.classify.enabled': '启用',
  'pages.systemConfig.classify.disabled': '禁用',
  'pages.systemConfig.classify.namePlaceholder': '请输入分类名称',
  'pages.systemConfig.classify.keyPlaceholder': '请输入分类标识（英文）',
  'pages.systemConfig.classify.infoPlaceholder': '请输入分类说明',
  'pages.systemConfig.settings.title': '配置管理',
  'pages.systemConfig.settings.selectClassify': '请选择左侧分类',
  'pages.systemConfig.settings.noConfig': '当前分类下暂无配置项',
  'pages.systemConfig.settings.save': '保存配置',
  'pages.systemConfig.settings.reset': '重置',
  'pages.systemConfig.settings.saveSuccess': '保存成功',
  'pages.systemConfig.settings.saveError': '保存失败',
  'pages.systemConfig.settings.manageClassify': '管理分类',
  'pages.systemConfig.settings.searchClassify': '搜索分类',
};
